import React from 'react';
import { __experimentalFormField as FormField, withChangeableValue, withTransformer } from '@cp/ds/src/components/form';
import { Switch } from '@cp/ds/src/components/switch';
import { FormFieldName } from '../model/form';

type SwitchInputProps = {
  name: string;
  value?: boolean;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const toCheckedEvent = (checked: boolean) => ({ target: { checked } }) as unknown as React.ChangeEvent<HTMLInputElement>;

const booleanTransformer = {
  toControl: (v?: boolean | null) => Boolean(v),
  fromControl: (v?: boolean) => v ?? false,
};

const SwitchInput: React.FC<SwitchInputProps> = ({ name, value = false, disabled, onChange }) => (
  <Switch
    disabled={disabled}
    inputName={name}
    label="Постоянный ситтер"
    onChange={(checked) => onChange?.(toCheckedEvent(checked))}
    value={value}
  />
);

const ChangeableSwitch = withChangeableValue<boolean, HTMLInputElement>(SwitchInput, (e) => e.target.checked);

const SwitchControl = withTransformer(ChangeableSwitch, booleanTransformer);

export const RegularSpecialistField: React.FC = () => {
  return <FormField Control={SwitchControl} name={FormFieldName.RegularSpecialist} />;
};
